import { DatePipe } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { Game, ScorePronos } from "src/app/models/games/games.models";
import { MathsService } from "src/app/services/maths/maths-service";
import { StatsService } from "src/app/services/stats/stats-service";

@Component({
  selector: "app-sidenav-list",
  templateUrl: "./sidenav-list.component.html",
  styleUrls: ["./sidenav-list.component.scss"],
})
export class SidenavListComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();
  actualGameList: Game[] = [];
  gameDay;
  teamList: string[] = [];
  percentResult: number = 0;
  gameScoring: ScorePronos;
  selectedGameIndex: number | null = null;
  gamesDate: string;
  gamesDateToShow: string;
  lastUpdate = "04/12/2024 ";

  constructor(
    private statsService: StatsService,
    private mathsService: MathsService,
    private datePipe: DatePipe,
    private router: Router
  ) {
    const today = new Date();
    this.gamesDate = this.datePipe.transform(today, "yyyy/MM/dd");
    this.gamesDateToShow = this.datePipe.transform(today, "dd/MM/yyyy");
    console.log("gamedatetoshow = ", this.gamesDateToShow);

    this.getSchedule();
  }

  async ngOnInit() {
    this.statsService.getCurrentGameList().subscribe((gameList) => {
      this.actualGameList = gameList;
    });
  }

  addEvent(date: Date | null) {
    if (!date) {
      console.warn("Date invalide ou vide !");
      return;
    }

    this.gamesDate = this.datePipe.transform(date, "yyyy/MM/dd");
    this.gamesDateToShow = this.datePipe.transform(date, "dd/MM/yyyy");
    this.getSchedule();
    this.onViewGame(0);
  }

  getSchedule() {
    this.statsService.getGameList(this.gamesDate).subscribe((apiResponse) => {
      if (!apiResponse.length) {
        // alert("Pas de match a cette date");
        this.redirectTo("/game/nogame");
        return;
      }
      this.statsService.game.next(apiResponse);
      this.redirectTo("/game/view/0");
      this.processGames(apiResponse);
      localStorage.setItem("gameList", JSON.stringify(apiResponse));
    });
  }

  private async processGames(apiResponse: Game[]) {
    let goodBetCount = 0;

    console.log("Début du traitement des jeux :", apiResponse);

    try {
      // Utilisation de for..of pour traiter chaque jeu
      for (const game of apiResponse) {
        try {
          this.gameDay = new Date(apiResponse[0].date).toLocaleString().split(' ')[0];

          const gameScoring = await firstValueFrom(this.statsService.getScoring(game.id));
          if (!gameScoring) {
            console.warn(`Scoring non disponible pour le jeu ${game.id}`);
            continue;
          }

          const [statsHome, statsRoad, standingHome, standingRoad] = await Promise.all([
          // const [ standingHome, standingRoad] = await Promise.all([
            firstValueFrom(this.statsService.getTeamStats(this.statsService.getCorrectName(game.homeTeam), this.gamesDate)),
            firstValueFrom(this.statsService.getTeamStats(this.statsService.getCorrectName(game.roadTeam), this.gamesDate)),
            firstValueFrom(this.statsService.getStandings(game.homeTeam, this.gameDay)),
            firstValueFrom(this.statsService.getStandings(game.roadTeam, this.gameDay)),
          ]);

          // BY SCORE
          const pronoWinner = this.mathsService.getWinner(
            gameScoring.averageRoadPoints,
            gameScoring.averageHomePoints,
            game.homeTeam,
            game.roadTeam
          );



          // BY RANK
          // const pronoWinner = this.mathsService.getBestRankInverted(
          //   +standingRoad.road.ranks,
          //   +standingHome.home.ranks,
          //   game.homeTeam,
          //   game.roadTeam
          // );
          // console.log("aso---------", standingHome);
          // console.log("aso---------", standingRoad);
          // console.log("aso---------", pronoWinner);

          const gameElement = document.querySelector(`#game-${game.id}`);
          if (gameElement && game.homeScore !== null) {
            if (game.winner === pronoWinner) {
              gameElement.classList.add("winner");
              goodBetCount++;
            } else {
              gameElement.classList.add("lose");
            }
          }
        } catch (error) {
          console.error(`Erreur dans le traitement du jeu ${game.id} :`, error);
        }
      }

      // Vérifier la longueur de la liste avant de calculer le pourcentage
      if (this.actualGameList.length > 0) {
        this.percentResult = (goodBetCount / this.actualGameList.length) * 100;
      } else {
        console.warn("La liste des jeux est vide, pourcentage non calculé.");
        this.percentResult = 0;
      }

      console.log(`Pourcentage de succès : ${this.percentResult}%`);
    } catch (error) {
      console.error("Erreur globale dans processGames :", error);
    }
  }

  onSidenavClose() {
    this.sidenavClose.emit();
  }

  redirectTo(uri: string) {
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }

  onViewGame(id: number) {
    this.selectedGameIndex = id;
    this.redirectTo(`/game/view/${id}`);
  }

  onViewTickets() {
    this.selectedGameIndex = 100;
    this.redirectTo("/game/tickets");
  }

  trackByGameId(index: number, game: Game): number {
    return game.id;
  }
}
